import { ADMIN_ACTIONS } from "./actions";

export interface IAdminState {
  devices: any[];
  isPending: boolean;
  isError: boolean;
  errorMessage: string;
}

const initialState: IAdminState = {
  isPending: false,
  isError: false,
  errorMessage: "",
  devices: [],
};

export const adminReducer = (state: IAdminState = initialState, action): IAdminState => {
  switch (action.type) {
    case ADMIN_ACTIONS.GET_DEVICES_PENDING: {
      return {
        ...state,
        isPending: true,
      };
    }
    case ADMIN_ACTIONS.GET_DEVICES_ERROR: {
      return {
        ...state,
        isPending: false,
        isError: true,
        errorMessage: action.payload,
      };
    }
    case ADMIN_ACTIONS.GET_DEVICES_OK: {
      return {
        ...state,
        isPending: false,
        isError: false,
        devices: [
          ...action.payload,
        ],
      };
    }
    default:
      return state;
  }
};
